/**
 * Elige blanco o tinta para el texto que va encima del color del cliente.
 *
 * Se guarda un solo hex por tenant, así que el color de texto no se configura: se deriva de
 * la luminancia. Es lo que permite que la marca sea azul, verde o naranja sin que la
 * numeración de la portada o la categoría activa queden ilegibles.
 *
 * (Copia del util del panel: las apps no se importan entre sí y son 20 líneas.)
 */
export function contrasteSobre(hex: string): string {
  return luminancia(hex) > 0.55 ? '#201E1D' : '#FFFFFF';
}

/** Luminancia relativa (sRGB). Devuelve 0 si el hex no es válido. */
export function luminancia(hex: string): number {
  const m = /^#?([\da-f]{6})$/i.exec(hex.trim());
  if (!m) return 0;
  const n = parseInt(m[1]!, 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
